import React from 'react';

// Styles & Assets
import styles from './WrapperSendButton.module.css';
import { MdSend } from 'react-icons/md';

interface Props extends React.ComponentPropsWithoutRef<'div'> {
    children: React.ReactElement
    handleClick: () => void
}

const WrapperSendButton: React.FC<Props> = ({ children, className, handleClick }) => {

    return (
        <div className={`${styles.container} ${className}`}>
            {children}
            <MdSend className={styles.sendIcon} onClick={handleClick} />
        </div>
    );
};

export default WrapperSendButton;